import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import { AppList } from './AppList';

const AppMenu = forwardRef(({
    items,
    onItemClick,
    sx = {}
}, ref) => {
    const [openSubMenus, setOpenSubMenus] = useState({});

    const getIcon = (item) => {
        return item.subItems && (
            openSubMenus[item.label] ?
                <ExpandLess /> :
                <ExpandMore />
        );
    };

    const handleSubMenuToggle = (label) => {
        setOpenSubMenus(prev => ({
            [label]: !prev[label]
        }));
    };

    return (
        <Box sx={{ display: 'flex', gap: 2, ...sx }} ref={ref}>
            {items.map((item) => (
                <Box
                    key={item.label}
                    onClick={() => item.subItems && handleSubMenuToggle(item.label)}
                    sx={{
                        position: 'relative'
                    }}
                >
                    <Button
                        color="inherit"
                        onClick={() => {onItemClick?.(item.label);}}
                        endIcon={getIcon(item)}>
                        {item.label}
                    </Button>
                    {item.subItems && (
                        <Box
                            sx={{
                                display: openSubMenus[item.label] ? "block" : "none",
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                bgcolor: 'background.paper',
                                boxShadow: 3,
                                minWidth: 200,
                                zIndex: 1300,
                            }}
                        >
                            <AppList
                                items={item.subItems}
                                onItemClick={onItemClick}
                                sx={{ color: 'text.primary' }}
                                variant="button"
                                dividers
                            />
                        </Box>
                    )}
                </Box>
            ))}
        </Box>
    );
});

AppMenu.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        href: PropTypes.string,
        onClick: PropTypes.func,
        subItems: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string.isRequired,
            href: PropTypes.string,
            onClick: PropTypes.func,
        })),
    })).isRequired,
    openSubMenus: PropTypes.object,
    onSubMenuToggle: PropTypes.func.isRequired,
    sx: PropTypes.object,
};

AppMenu.displayName = 'AppMenu';

export { AppMenu };